<template>
    <form :id=computed_id>
        <div class="d-flex">
            <h5 v-if="title" class="card-title">{{title}}</h5>
            <div class="ml-auto">
                <!-- <slot name="toolbar" :get="get"></slot> -->
            </div>
        </div>
        <div v-if="!row || row == 'true'" class="">
            <div :class="'row justify-content-'+(horizontal ? horizontal : 'start')+' align-items-'+(vertical ? vertical : 'end')">
                <slot name="body" :control="control" :data="data"></slot>
            </div>
        </div>
        <div v-else>
            <slot name="body" :control="control" :data="data"></slot>
        </div>
        <!-- <hr> -->
        <div class="text-right">
            <button :id="computed_id_submit" type="submit" hidden></button>
            <slot name="footbar" :submit="submit" :data="data"></slot>
        </div>
        <div>
            <slot name="footer" :data="data"></slot>
        </div>
    </form>
</template>

<script>
import Axios from 'axios';

export default {
    props: [
        'id',
        'title',
        'vertical',
        'horizontal',
        'row',
        'onLoad',
        'onModal',
    ],
    data() { return {
        control: {},
        data: {},
        url: '',
        type: 'GET',
    }},
    computed: {
        computed_id() {
            if(this.id == undefined) {
                return ('form-' + this._uid);
            } else {
                return this.id;
            }
        },
        computed_id_submit() {
            if(this.id == undefined) {
                return ('form-submit-' + this._uid);
            } else {
                return ('form-submit-' + this.id);
            }
        }
    },
    mounted() {
        const vm = this;
        const form = $('#' + vm.computed_id);
        const submitButton = $('#' + vm.computed_id_submit);

        if(vm.onLoad) {
            vm.get(vm.onLoad);
        }

        vm.$on('padreCambio', function(padre) {
            vm.$emit('broadcastPadreCambio', padre);
        });

        vm.$on('submitEvent', function(type) {
            submitButton.click();
        });
        
        vm.$parent.$on('openModal', function() {
            if(vm.onModal) {
                vm.get(vm.onModal);
            }
        });

        vm.$on('closeModal', function() {
            console.log('formulario cierra modal');
            vm.$parent.$emit('closeModal');
        });

        form.submit(function(event) {
            event.preventDefault();

            const data = form.serialize();
            switch (vm.type) {
                case 'post':
                    vm.post(data);
                    break;
            
                default:
                    break;
            }
            /* const pars = {};        
            const data = form.serializeArray();
            data.forEach(item => {
                if(item.name) {
                    if(item.name.includes('[]')) {
                        item.name = item.name.substring(0, item.name.length - 2);
                        if(Array.isArray(pars[item.name])) {
                            pars[item.name].push(item.value);              
                        } else {
                            pars[item.name] = [item.value];
                        }
                    } else {
                        pars[item.name] = item.value;
                    }
                }
            }); */
        });
    },
    methods: {
        get(url, params) {
            Axios.get(url).then(res => {
                this.data = res.data;
            }).catch(e => {
                if(this.$store.state.debug) {
                    toastr["error"](e, 
                        'Error en el componente n-form '+ this.computed_id
                    );
                }
            });
        },
        post(data) {
            Axios.post(this.url, data).then(res => {
                toastr["success"](res.data.message ? res.data.message : null, "Éxito");
                this.$parent.$emit('closeModal');
            }).catch(e => {
                if(this.$store.state.debug) {
                    toastr["error"](e, 
                        'Error en el componente n-form '+ this.computed_id
                    );
                }
            })
        },
        submit(url, type) {
            this.url = url;
            this.type = (type ? type.toLowerCase() : 'get');
            this.$emit('submitEvent');
        },
    },
}
</script>